/* eslint-disable @typescript-eslint/no-explicit-any */
import { IdentityProvider, useSwanStyleKeys, useUserContext, useIdentity } from '@vp/ubik-context'
import { App } from './App'
import { ContactChannelsProvider } from '@vp/contact-channels'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BannerStatusProvider } from './contexts/StatusContext'
import { ChatStatusProvider } from './contexts/ChatStatusProvider'
import { BoundedContent, SWAN_STYLE_KEY_MAP, ScreenClassProvider } from '@vp/swan'
import { DataConfig } from './types/config.types'
import { ConfigProvider } from './contexts/ConfigProvider'
import LocalizationProvider from './contexts/LocalizationProvider'

export interface Props {
  contactChannels: any
  config: DataConfig
  localization: Record<string, any>
}

const styleSheetKeys = [
  SWAN_STYLE_KEY_MAP.button,
  SWAN_STYLE_KEY_MAP.accordion,
  SWAN_STYLE_KEY_MAP.grid,
  SWAN_STYLE_KEY_MAP.modalDialog,
  SWAN_STYLE_KEY_MAP.hidden,
  SWAN_STYLE_KEY_MAP.icon,
  SWAN_STYLE_KEY_MAP.toggleSwitch,
  SWAN_STYLE_KEY_MAP.core,
  SWAN_STYLE_KEY_MAP.visible,
  SWAN_STYLE_KEY_MAP.standardTile,
  SWAN_STYLE_KEY_MAP.progressiveImage,
  SWAN_STYLE_KEY_MAP.utility,
  SWAN_STYLE_KEY_MAP.popover,
  SWAN_STYLE_KEY_MAP.alertBox,
  SWAN_STYLE_KEY_MAP.carousel,
  SWAN_STYLE_KEY_MAP.spinner,
  SWAN_STYLE_KEY_MAP.selectionSet,
]
const InitChannels = ({ children }) => {
  const { locale, tenant } = useUserContext()
  const auth = useIdentity()

  return (
    <ContactChannelsProvider locale={locale} tenant={tenant} origin="Help Center" auth={auth?.auth} useRecaptcha callMeConfig={{ allowVPNs: true }}>
      {children}
    </ContactChannelsProvider>
  )
}

export const createAuthConfig = (culture: string, isDevelopment = false) => ({
  culture,
  developmentMode: isDevelopment,
  options: {
    requireSession: true,
    customText: 'Sign in to see your account',
  },
})
export const Fragment = (props: Props) => {
  const { tenant = 'vistaprint', locale } = useUserContext()

  const queryClient = new QueryClient()
  useSwanStyleKeys(styleSheetKeys)

  return (
    <ConfigProvider config={props.config}>
      <ScreenClassProvider>
        <LocalizationProvider locale={locale} localization={props.localization} tenant="vistaprint">
          <IdentityProvider auth={createAuthConfig(locale || 'en-us')}>
            <QueryClientProvider client={queryClient}>
              <BannerStatusProvider tenant={tenant} locale={locale}>
                <ChatStatusProvider>
                  <BoundedContent pt={9} style={{ maxWidth: '1440px' }}>
                    <InitChannels>
                      <App locale={locale} tenant="vistaprint" trackingTenant="vistaprint" contactChannels={props.contactChannels} segmentKey="" />
                    </InitChannels>
                  </BoundedContent>
                </ChatStatusProvider>
              </BannerStatusProvider>
            </QueryClientProvider>
          </IdentityProvider>
        </LocalizationProvider>
      </ScreenClassProvider>
    </ConfigProvider>
  )
}
